// extracted by mini-css-extract-plugin
export var notificationHost = "_md-0";